import { Variant } from '~/components/Text'
import { textSizings } from '../enum'
import { OptionBorder, OptionContainer, OptionLabel } from '../styles'
import { MultiselectionProps, Option } from '../type'
import { MultiselectionButton } from './styles'

export interface MultiselectionOptionProps
  extends Omit<MultiselectionProps, 'options'> {
  shouldShowOption: (index: number, beforePositioned: boolean) => boolean
  isBeforePositioned?: boolean
  option: Option
  index: number
  textSize?: Variant | null
  isOptionChecked: (option: Option) => boolean
  labelTextVariant?: Variant
}

const MultiselectionOption = ({
  option,
  labelTextVariant,
  index,
  onChange,
  tabIndex,
  direction,
  heightClass,
  optionLabelsPosition,
  disabled = false,
  nonFocusable = false,
  isBeforePositioned = false,
  shouldShowOption,
  isOptionChecked,
  id,
  ...props
}: MultiselectionOptionProps) => {
  const labelVariant = labelTextVariant || textSizings[heightClass].optionLabel

  const optionId = `${id}-${option.uuid}`

  return (
    <OptionContainer
      heightClass={heightClass}
      key={option.uuid}
      direction={direction}
    >
      {(isBeforePositioned || optionLabelsPosition === 'alternating') && (
        <OptionLabel
          heightClass={heightClass}
          isBeforePositioned={true}
          show={shouldShowOption(index, true)}
          direction={direction}
          variant={labelVariant}
          htmlFor={optionId}
        >
          {option.des}
        </OptionLabel>
      )}
      <OptionBorder
        heightClass={heightClass}
        nonFocusable={nonFocusable}
        disabled={disabled}
        onClick={(event) => onChange(option, event)}
      >
        <MultiselectionButton
          type='checkbox'
          heightClass={heightClass}
          disabled={disabled}
          value={option.uuid}
          checked={isOptionChecked(option)}
          tabIndex={nonFocusable ? -1 : tabIndex}
          readOnly
          id={optionId}
          {...props}
        />
      </OptionBorder>
      {(optionLabelsPosition === 'alternating' || !isBeforePositioned) && (
        <OptionLabel
          heightClass={heightClass}
          isBeforePositioned={false}
          show={shouldShowOption(index, false)}
          direction={direction}
          variant={labelVariant}
          htmlFor={optionId}
        >
          {option.des}
        </OptionLabel>
      )}
    </OptionContainer>
  )
}

export default MultiselectionOption
